import { type FunctionComponent, useCallback, useState } from "react";

import { paywall } from "shared/data";

import { useSearchContext } from "scmp-app/components/search/contexts";

import IconCheckboxChecked from "./icon-checkbox-checked.svg";
import IconCheckboxCheckedOff from "./icon-checkbox-off.svg";
import { BoldWord, Checkbox, Container, Content } from "./styles";

type Props = {
  className?: string;
};

export const PlusCheckbox: FunctionComponent<Props> = ({ className }) => {
  const { paywallTypeIds, setArticleTypeIds, setContentTypes, setPaywallTypeIds, setSectionIds } =
    useSearchContext();
  const [isChecked, setIsChecked] = useState(paywallTypeIds?.includes(paywall.scmpPlus.entityUuid));

  const renderCheckbox = () => {
    if (isChecked) {
      return <IconCheckboxChecked />;
    }
    return <IconCheckboxCheckedOff />;
  };

  const handleClick = useCallback(() => {
    const newIsChecked = !isChecked;
    setIsChecked(newIsChecked);
    setArticleTypeIds?.([]);
    setContentTypes?.(newIsChecked ? ["ARTICLE"] : ["ARTICLE", "VIDEO", "GALLERY"]);
    setSectionIds?.([]);
    setPaywallTypeIds?.(newIsChecked ? [paywall.scmpPlus.entityUuid] : []);
  }, [isChecked, setArticleTypeIds, setContentTypes, setPaywallTypeIds, setSectionIds]);

  return (
    <Container className={className} onClick={handleClick}>
      <Checkbox>{renderCheckbox()}</Checkbox>
      <Content $isPlusPage>
        Only show<BoldWord> SCMP Plus </BoldWord>articles
      </Content>
    </Container>
  );
};

PlusCheckbox.displayName = "PlusCheckbox";
